import { TrackingEvent } from '@manakincubber/tiime-tracking';

export const USER_LOG_OUT = 'User Log Out';

export class UserLogOut implements TrackingEvent {
  readonly name = USER_LOG_OUT;
}
